var path = 'src/app/patients/nurture-samples/nurture-samples.html';
var html = "<h1 class=page-header>Samples</h1> <div nurture-samples-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/nurture-samples/nurture-samples.html
 ** module id = 547
 ** module chunks = 0
 **/